// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r5-6";
export var imgContainer = "_r5-3";
export var menuIcon = "_r5-5";
export var pillWrapper = "_r5-2";
export var pillsContainer = "_r5-1";
export var subscriptionCard = "_r5-0";
export var subscriptionLogo = "_r5-4";